import { atom } from 'jotai';

export type ExperimentalGroup = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'else';
export const atomUserValues = atom<{
  experimentalGroups: Record<string, ExperimentalGroup>;
}>();
